
// 导出页面为PDF格式
import Vue from 'vue'
import EXIF from 'exif-js'
// Orientation
// 1	正常
// 2	正常镜像
// 3	顺时针旋转180°
// 4	顺时针旋转180°镜像
// 5	顺时针旋转270°镜像
// 6	顺时针旋转270°
// 7	顺时针旋转90°镜像
// 8	顺时针旋转90°

Vue.prototype.getExif = function (file, compress) {//compress是否压缩
  return new Promise(function (resolve, reject) {
    var result = file
    // console.log('原文件', file)
    EXIF.getData(file, function () {
      var Orientation = EXIF.getTag(this, "Orientation");
      console.log("Orientation>>>>>>", Orientation);

      //转换成base64
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = e => {

        // if (Orientation == 1) {
        //   console.log("图片无需处理");
        //   resolve(result)
        // } else {
        var uploadBase64 = new Image();
        uploadBase64.src = e.target.result;

        uploadBase64.onload = function () {
          //修正旋转图片
          var expectWidth = uploadBase64.width;
          var expectHeight = uploadBase64.height;
          var quality = 1;
          // console.log('原始宽高', uploadBase64.width, uploadBase64.width)

          //压缩
          // console.log('原大小kb', file.size / 1024)
          // if (compress) {
          if (compress && file.size / 1024 > 800) {
            quality = 0.4//图片质量
            console.log('已压缩')

            // 尺寸缩放暂时不用
            // expectWidth = toCompress(uploadBase64.width, uploadBase64.width)[0];
            // expectHeight = toCompress(uploadBase64.width, uploadBase64.height)[1];
            // console.log('压缩后宽高', expectWidth, expectHeight)

          } else {
            console.log('未压缩')

          }

          var canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");
          canvas.width = expectWidth;
          canvas.height = expectHeight;

          ctx.drawImage(uploadBase64, 0, 0, expectWidth, expectHeight);
          var base64 = null;
          if (Orientation == 1) {
            console.log("图片无需处理");

          } else {
            if (Orientation !== "" && Orientation != 1) {
              switch (Orientation) {
                case 6:
                  console.log("顺时针旋转270度");
                  rotateImg(uploadBase64, "left", canvas);
                  break;
                case 8:
                  console.log("顺时针旋转90度");
                  rotateImg(uploadBase64, "right", canvas);
                  break;
                case 3:
                  console.log("顺时针旋转180度");
                  rotateImg(uploadBase64, "horizen", canvas);
                  break;
              }
            }
          }
          //输出转换后的base64图片(quality<1说明压缩)
          var base64 = canvas.toDataURL(file.type, quality);

          //输出转换后的流
          var newBlob = convertBase64UrlToBlob(base64, file.type);
          console.log('结果', newBlob)
          console.log('原大小kb', file.size / 1024)

          console.log('结果大小kb', newBlob.size / 1024)

          resolve(newBlob)

        };
        // }
      };
    })
  })
}
// compress 图片压缩处理
function toCompress(originWidth, originHeight) {
  // 图片原始尺寸originWidth  originHeight
  // 最大尺寸限制
  var maxWidth = 400, maxHeight = 400;
  // 目标尺寸
  var targetWidth = originWidth, targetHeight = originHeight;
  // 图片尺寸超过400x400的限制
  if (originWidth > maxWidth || originHeight > maxHeight) {
    if (originWidth / originHeight > maxWidth / maxHeight) {
      // 更宽，按照宽度限定尺寸
      targetWidth = maxWidth;
      targetHeight = Math.round(maxWidth * (originHeight / originWidth));
    } else {
      targetHeight = maxHeight;
      targetWidth = Math.round(maxHeight * (originWidth / originHeight));
    }
  }

  return [targetWidth, targetHeight]
}
//对图片旋转处理
function rotateImg(img, direction, canvas) {
  console.log("开始旋转图片");
  //图片旋转4次后回到原方向
  if (img == null) return;
  var height = img.height;
  var width = img.width;
  var step = 2;

  if (direction == "right") {
    step++;
  } else if (direction == "left") {
    step--;
  } else if (direction == "horizen") {
    step = 2; //不处理
  }
  //旋转角度以弧度值为参数
  var degree = step * 90 * Math.PI / 180;
  var ctx = canvas.getContext("2d");
  switch (step) {
    case 0:
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0);
      break;
    case 1:
      canvas.width = height;
      canvas.height = width;
      ctx.rotate(degree);
      ctx.drawImage(img, 0, -height);
      break;
    case 2:
      canvas.width = width;
      canvas.height = height;
      ctx.rotate(degree);
      ctx.drawImage(img, -width, -height);
      break;
    case 3:
      canvas.width = height;
      canvas.height = width;
      ctx.rotate(degree);
      ctx.drawImage(img, -width, 0);
      break;
  }
  console.log("结束旋转图片");
}

function convertBase64UrlToBlob(urlData) {

  var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte

  //处理异常,将ascii码小于0的转换为大于0
  var ab = new ArrayBuffer(bytes.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }

  return new Blob([ab], { type: 'image/png' });
}



// WEBPACK FOOTER //
// ./src/utils/exifUse.js